var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    {
      staticClass: "sub-menu",
      staticStyle: { "margin-bottom": "15px" },
      attrs: { "slider-color": "primary" }
    },
    [
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/delegation-rate", exact: "" }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("settings.delegationRate.menu.standardRates")) +
              " "
          )
        ]
      ),
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/delegation-rate/mileage" }
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("settings.delegationRate.menu.standardMileageRates")
              ) +
              " "
          )
        ]
      ),
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/delegation-rate/custom" }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("settings.delegationRate.menu.specialRates")) +
              " "
          )
        ]
      ),
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/delegation-rate/group" }
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("settings.delegationRate.menu.group")) + " "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }